import { EProductStatus } from "@api/models/IProduct";
import SSAccountCard from "@core-components/accountCard/SSAccountCard";
import SSBoughtFooterCard from "@core-components/accountCard/components/SSBoughtFooterCard";
import SSProductDetailLines from "@core-components/product/component/SSProductDetailLines";
import AppSkeleton from "@modules/loader/AppSkeleton";
import { EGame } from "@modules/order/stores/models/EGame";
import { EItemReason } from "@modules/order/stores/models/EItemReason";
import type IBasketAccount from "@modules/order/stores/models/IBasketItem.models";

const AppSkeletonProductCard: React.FC = () => {
  const fakeAccount: IBasketAccount = {
    accountId: 0,
    game: EGame.LoL,
    i18nKey: "",
    imageUrl: "",
    prefix: "",
    price: 0,
    reason: EItemReason.PRODUCT,
    region: "",
  };

  return (
    <SSAccountCard
      header={<AppSkeleton fullWidth className="!h-[200px] block" />}
    >
      <SSProductDetailLines
        blueEssence={""}
        region={""}
        i18nKey={""}
        status={EProductStatus.RANKED_READY}
      />
      <SSBoughtFooterCard account={fakeAccount} isOutOfStock={false} />
    </SSAccountCard>
  );
};

export default AppSkeletonProductCard;
